import EstadisticasModule from "./estadisticas/estadisticas.module";
import ListasModule from "./listas/listas.module";
import AppModule from "./app.module";
import IncidenciasModule from "./incidencias/incidencias.module";
import TareasModule from "./tareas/tareas.module";
import TiposUniGesModule from "./tipos-uniges/tiposUniGes.module";
import TiposModule from "./tipos/tipos.module";
import InspectoresDistritosModule from "./mantenimiento/inspectoresDistritos/inspectoresDistritos.module";

typeof EstadisticasModule;
typeof ListasModule;
typeof AppModule;
typeof IncidenciasModule;
typeof TareasModule;
typeof TiposModule;
typeof TiposUniGesModule;
typeof InspectoresDistritosModule;

export default {};